import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/rollback-frontend/src/app/[lang]/(public)/error.tsx");
